import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, getCurrentInstance, nextTick } from 'vue';

/**
 * Callback data structure per compatibilità con API esistente
 */
interface ModalCallbackData {
	instance: any;
	data: any;
}

/**
 * Callback function type
 */
type ModalCallback = (callbackData: ModalCallbackData) => void;

/**
 * Props interface per Modal component
 */
interface ModalProps {
	/** Titolo del modal */
	title?: string;
	/** Componente Vue da renderizzare nel body */
	body: any; // Component type
	/** Props da passare al componente body */
	bodyProps?: Record<string, any>;
	/** Testo bottone conferma */
	confirmButtonText?: string;
	/** Testo bottone cancellazione */
	cancelButtonText?: string;
	/** Callback per azione conferma */
	onConfirm: ModalCallback;
	/** Mostra bottone conferma */
	confirmButton?: boolean;
	/** Callback per azione cancellazione */
	onCancel?: ModalCallback;
}

// Props definition con valori predefiniti

export default /*#__PURE__*/_defineComponent({
  __name: 'Modal',
  props: {
    title: { default: '' },
    body: null,
    bodyProps: { default: () => ({}) },
    confirmButtonText: { default: 'Conferma' },
    cancelButtonText: { default: 'Annulla' },
    onConfirm: null,
    confirmButton: { type: Boolean, default: true },
    onCancel: { type: Function, default: undefined }
  },
  setup(__props: any, { expose }) {

const props = __props as { title: string, body: any, bodyProps: Record<string, any>, confirmButtonText: string, cancelButtonText: string, onConfirm: ModalCallback, confirmButton: boolean, onCancel: ModalCallback };



// State reattivo
const isOpen = ref<boolean>(false);
const isValid = ref<boolean>(true);
const isLoading = ref<boolean>(false);
const bodyData = ref<any>(null);

// Current instance per retrocompatibilità
const instance = getCurrentInstance();

/**
 * Callback for dynamic component validation event
 */
const onValidate = (valid: boolean): void => {
	isValid.value = valid;
};

/**
 * Callback for dynamic component data change
 */
const onChange = (data: any): void => {
	bodyData.value = data;
};

/**
 * Callback for confirmation event
 */
const onConfirmPressed = (): void => {
	const callbackData: ModalCallbackData = {
		instance: instance?.proxy || instance,
		data: bodyData.value,
	};

	props.onConfirm(callbackData);
};

/**
 * Callback for cancellation event
 */
const onCancelPressed = (): void => {
	close();

	if (props.onCancel) {
		const callbackData: ModalCallbackData = {
			instance: instance?.proxy || instance,
			data: bodyData.value,
		};

		props.onCancel(callbackData);
	}
};

/**
 * Handle dialog closed event - cleanup DOM element
 */
const onDialogClosed = (): void => {
	// Il cleanup del DOM viene gestito automaticamente dal modal factory
	// Non serve rimuovere manualmente l'elemento in Vue 2.7
};

/**
 * Set modal as loading
 */
const startLoading = (): void => {
	isLoading.value = true;
};

/**
 * Stop modal from loading
 */
const stopLoading = (): void => {
	isLoading.value = false;
};

/**
 * Get current modal data
 */
const getData = (): any => {
	return bodyData.value;
};

/**
 * Close modal
 */
const close = (): void => {
	isOpen.value = false;
};

// Lifecycle
onMounted(() => {
	isOpen.value = true;
});

// Expose methods per retrocompatibilità con API esistente
expose({
	startLoading,
	stopLoading,
	getData,
	close,
	// Properties per debugging
	isOpen,
	isValid,
	isLoading,
	bodyData,
});

return { __sfc: true,props, isOpen, isValid, isLoading, bodyData, instance, onValidate, onChange, onConfirmPressed, onCancelPressed, onDialogClosed, startLoading, stopLoading, getData, close }
}

})